export const allowedTypes = ['email', 'navigate', 'call', 'sms'];

export const restrictHeaderButtons = ['loan'];

export const automatedActivityCategory = [
  {
    code: 'AUTOMATED',
    name: 'AUTOMATED',
  },
];

export const CASE = 'ccase';
export const CURRENT_STATE_ID_CODE = 'currentState.stateId';
